export const authRoutes = [
  {
    component: () => import('@xstudios/xapp-auth/pages/LoginEntryPage.vue'),
    meta: { layout: false, requiresAuth: false },
    name: 'login',
    path: '/login',
  },
  {
    component: () => import('@xstudios/xapp-auth/pages/GoogleLoginPage.vue'),
    meta: { layout: false, requiresAuth: false },
    name: 'login-google',
    path: '/login/google',
  },
  {
    component: () => import('@xstudios/xapp-auth/pages/AllauthLoginPage.vue'),
    meta: { layout: false, requiresAuth: false },
    name: 'login-allauth',
    path: '/login/allauth',
  },
  {
    component: () => import('@xstudios/xapp-auth/pages/FastApiLoginPage.vue'),
    meta: { layout: false, requiresAuth: false },
    name: 'login-fastapi',
    path: '/login/fastapi',
  },
]
